import Carousel from '@/components/reusable/carousel/Carousel';
import { SplideSlide } from '@splidejs/react-splide';
import { similarHousesCarouselSetting } from '@/components/houses/_constants';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import styles from './SimilarProductsContainerSkeleton.module.scss';
const SimilarProductsContainerSkeleton = () => {
  return <Box className={styles['similar-skeleton-container']} data-sentry-element="Box" data-sentry-component="SimilarProductsContainerSkeleton" data-sentry-source-file="SimilarProductsContainerSkeleton.tsx">
      <Carousel opts={similarHousesCarouselSetting} data-sentry-element="Carousel" data-sentry-source-file="SimilarProductsContainerSkeleton.tsx">
        {[1, 2, 3, 4, 5].map((_, index) => <SplideSlide key={`SIMILAR_SKELETON_${index}`}>
            <Box className={styles['similar-skeleton-item']}>
              <Skeleton variant="rounded" width="100%" height="120px" />
              <Skeleton variant="rounded" width="50%" />
              <Skeleton variant="rounded" width="100%" />
              <Skeleton variant="rounded" width="75%" />
            </Box>
          </SplideSlide>)}
      </Carousel>
    </Box>;
};
export default SimilarProductsContainerSkeleton;